/**
 * Jak staré smí být načtení dat studenta, než se při návratu na kartu obnoví na pozadí.
 *
 * AIDEV-NOTE: Samostatný modul, ať ho sdílí komponenta i testy. Data studenta mění i to, co
 * aplikace neví: noční job (23:55) nuluje days_fulfills_plan a mění elixir_of_life_count, job
 * users-refresh-queue přepisuje ročník, termín přijímaček a školy ze Zóny a jiné zařízení nebo
 * záložka může změnit cokoli. Pět minut je delší než přepnutí na poznámky a kratší než pauza,
 * po které stojí za to počítadla zkontrolovat; plošné refetchOnFocus by zatěžovalo server při
 * každém přepnutí karty. [TD-472]
 */
export const USER_REFRESH_AFTER_MS = 5 * 60 * 1000;
